import React, { useEffect } from "react";
import { useAppDispatch } from "../../index";
import { Dictionaries } from "../../components/Dictionaries/Dictionaries";
import { fetchDictionaryTypes } from "../../store/slices/dicts";

export const DictionariesContainer = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchDictionaryTypes());
  }, []);

  return <Dictionaries />;
};
